import React, { Children, cloneElement, isValidElement } from "react";
import { RouteProps, Switch } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LocalizedSwitch = ({ children }: any) => {
  const { t, i18n } = useTranslation();

  const localizeRoutePath = (path?: string | string[]) => {
    switch (typeof path) {
      case "undefined":
        return undefined;
      case "object":
        return path.map((key) => `/${i18n.language}` + t(key));
      default:
        const isFallbackRoute = path === "*";

        return isFallbackRoute ? path : `/${i18n.language}` + t(path);
    }
  };

  return (
    <Switch>
      {Children.map(children, (child) =>
        isValidElement<RouteProps>(child)
          ? cloneElement(child, {
            ...child.props,
            path: localizeRoutePath(child.props.path),
          })
          : child
      )}
    </Switch>
  );
};

export default LocalizedSwitch;
